import { render, staticRenderFns } from "./qs4-04.vue?vue&type=template&id=14d7f689&scoped=true&"
import script from "./qs4-04.vue?vue&type=script&lang=js&"
export * from "./qs4-04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d7f689",
  null
  
)

export default component.exports